import { styled } from 'stitches.config'

export const RelatedProductsHeaderRoot = styled('div', {})
